import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
  Button,
  Autocomplete,
  Stack,
  FormControl,
  FormControlLabel,
  Radio
} from '@mui/material';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';
import { CustomInfosForm } from '../../../../assets/style/globalStyle';
import configAxios from '../../../../services/configAxios';
import Iconify from '../../../../@core/theme/Iconify';

const getDefaultFilter = (isBroker, id_broker) => ({
  filterDate: 'dtcadastro',
  ...(isBroker ? { id_broker } : {})
});

const PipelineFilters = (props) => {
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const isBroker = infoState.id_type_user === 2;
  const canSelectVend = !isBroker || infoState.id_profile === 1 || infoState.id_profile === 2;

  const [infosFilter, setInfosFilter] = useState(getDefaultFilter(isBroker, infoState.id_broker));
  const [infosPlans, setInfosPlans] = useState([]);
  const [infosBroker, setInfosBroker] = useState([]);
  const [infosVend, setInfosVend] = useState([]);

  useEffect(() => {
    configAxios
      .get('/products/getProductsLabel')
      .then((response) => setInfosPlans(response.data.filter((item) => item.codplano)))
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os planos, por favor, tente novamente!',
          'Atenção'
        );
      });

    if (isBroker) {
      loadVendors(infoState.id_broker);
      return;
    }

    configAxios
      .post('/brokers/listBrokerLabelUsers')
      .then((response) => setInfosBroker(response.data))
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as corretoras, por favor, tente novamente!',
          'Atenção'
        );
      });
  }, []);

  function loadVendors(id_broker) {
    if (!id_broker) {
      setInfosVend([]);
      return;
    }
    configAxios
      .get(`/brokers/listVendLabel/${id_broker}`)
      .then((response) => setInfosVend(response.data))
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os vendedores, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function withScope(filters) {
    const params = { ...filters };
    if (isBroker) {
      params.id_broker = infoState.id_broker;
      if (infoState.id_profile !== 1 && infoState.id_profile !== 2) {
        params.id_user = infoState.id;
      }
    }
    return params;
  }

  function HandleFilter() {
    props.onFilter(withScope(infosFilter));
  }

  function HandleClear() {
    const cleared = getDefaultFilter(isBroker, infoState.id_broker);
    setInfosFilter(cleared);
    if (isBroker) {
      loadVendors(infoState.id_broker);
    } else {
      setInfosVend([]);
    }
    props.onFilter(withScope(cleared));
  }

  return (
    <>
      <CustomInfosForm>Utilize os filtros abaixo para visualizar as vendas</CustomInfosForm>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
          <FormControl component="fieldset" variant="standard">
            <FormControlLabel
              control={
                <Radio
                  checked={infosFilter.filterDate === 'dtcadastro'}
                  onChange={(event) =>
                    setInfosFilter({ ...infosFilter, filterDate: event.target.value })
                  }
                  value="dtcadastro"
                  name="filterDate"
                />
              }
              label={<CustomInfosForm sx={{ mt: 1 }}>Data de cadastro</CustomInfosForm>}
            />
          </FormControl>
          <FormControl component="fieldset" variant="standard">
            <FormControlLabel
              control={
                <Radio
                  checked={infosFilter.filterDate === 'dtvigencia'}
                  onChange={(event) =>
                    setInfosFilter({ ...infosFilter, filterDate: event.target.value })
                  }
                  value="dtvigencia"
                  name="filterDate"
                />
              }
              label={<CustomInfosForm sx={{ mt: 1 }}>Data da vigência</CustomInfosForm>}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            name="dateinitial"
            fullWidth
            label="Data inicial"
            variant="outlined"
            size="small"
            type="date"
            value={infosFilter.dateinitial || ''}
            onChange={(event) =>
              setInfosFilter({ ...infosFilter, [event.target.name]: event.target.value })
            }
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            name="dateend"
            fullWidth
            label="Data final"
            variant="outlined"
            size="small"
            type="date"
            value={infosFilter.dateend || ''}
            onChange={(event) =>
              setInfosFilter({ ...infosFilter, [event.target.name]: event.target.value })
            }
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <Autocomplete
            options={infosPlans}
            value={
              infosPlans.find((item) => String(item.codplano) === String(infosFilter.codplano)) ||
              null
            }
            getOptionLabel={(option) => option.label || ''}
            isOptionEqualToValue={(option, value) => option.codplano === value.codplano}
            onChange={(event, value) =>
              setInfosFilter({ ...infosFilter, codplano: value ? value.codplano : '' })
            }
            renderInput={(params) => (
              <TextField {...params} label="Plano" size="small" variant="outlined" />
            )}
          />
        </Grid>
        {!isBroker && (
          <Grid item xs={12} md={2}>
            <Autocomplete
              options={infosBroker}
              value={
                infosBroker.find((item) => String(item.id) === String(infosFilter.id_broker)) ||
                null
              }
              getOptionLabel={(option) => option.label || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, value) => {
                setInfosFilter({
                  ...infosFilter,
                  id_broker: value ? value.id : '',
                  id_user: ''
                });
                loadVendors(value ? value.id : null);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Corretora" size="small" variant="outlined" />
              )}
            />
          </Grid>
        )}
        {canSelectVend && (
          <Grid item xs={12} md sx={{ minWidth: 180 }}>
            <Autocomplete
              options={infosVend}
              value={
                infosVend.find((item) => String(item.id) === String(infosFilter.id_user)) || null
              }
              getOptionLabel={(option) => option.label || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, value) =>
                setInfosFilter({ ...infosFilter, id_user: value ? value.id : '' })
              }
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" size="small" variant="outlined" fullWidth />
              )}
            />
          </Grid>
        )}
        <Grid item xs={12} md="auto">
          <Stack direction="row" alignItems="center" spacing={1} sx={{ height: '100%' }}>
            <Button
              variant="contained"
              size="medium"
              color="primary"
              onClick={HandleFilter}
              disabled={props.loading}
              startIcon={<Iconify icon="eva:funnel-outline" />}>
              Filtrar
            </Button>
            <Button variant="outlined" size="medium" onClick={HandleClear} disabled={props.loading}>
              Limpar
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

PipelineFilters.propTypes = {
  onFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default PipelineFilters;
